<template>
  <v-overlay
    :absolute="false"
    :opacity="0.95"
    :value="showOverlay"
    @click.native="showOverlay = false"
  >
    <v-container>
      <v-row align="center">
        <v-col :cols="7" :lg="5" :offset-lg="3">
          <navigation-items @click.native="(event) => event.stopPropagation()"/>
          <v-row no-gutters>
            <v-col id="col-close-overlay" @click.self="closeOverlay();" class="pa-2 mt-5">Close</v-col>
          </v-row>
        </v-col>
        <v-col :cols="5" :lg="4">
          <notification-list @click.native="(event) => event.stopPropagation()"/>
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>


<script>
import {EVENTBUS_TOPICS} from "@/lib/constants";
import {EventBus} from "@/lib/event-bus";
import NavigationItems from "@/components/application/NavigationItems";
import NotificationList from "@/components/application/NotificationList";


export default {
  name: "application-overlay",
  components: { NavigationItems, NotificationList },
  data() {
    return {
      showOverlay: false,
    };
  },

  methods: {
    closeOverlay() {
      this.showOverlay = false;
    },
  },
  mounted() {
    EventBus.$on(EVENTBUS_TOPICS.SHOW_OVERLAY, (showOverlay) => {
      this.showOverlay = showOverlay;
    });
  },
  beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.SHOW_OVERLAY);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.current-menu-item button {
  color: $inther-orange;
}

#col-close-overlay {
  background: #272727;
  border: 1px solid #777777;
  cursor: pointer;
  text-align: center;
}
</style>
